
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.016 3.5c2.851 0 3.208.012 4.328.063 1.118.051 1.881.229 2.55.489.69.268 1.276.626 1.86 1.21a5.148 5.148 0 011.21 1.86c.26.668.438 1.43.488 2.549.051 1.12.064 1.478.064 4.329s-.012 3.208-.064 4.328c-.05 1.12-.228 1.882-.488 2.55a5.148 5.148 0 01-1.21 1.86 5.15 5.15 0 01-1.86 1.211c-.669.26-1.432.437-2.55.488-1.12.051-1.477.063-4.328.063-2.852 0-3.21-.012-4.33-.063-1.117-.051-1.88-.229-2.549-.488a5.147 5.147 0 01-1.86-1.212 5.147 5.147 0 01-1.21-1.86c-.26-.667-.438-1.43-.488-2.547-.051-1.12-.063-1.479-.063-4.33s.012-3.208.063-4.328c.05-1.12.228-1.882.488-2.55a5.147 5.147 0 011.21-1.86 5.146 5.146 0 011.86-1.211c.669-.26 1.432-.438 2.55-.49 1.12-.05 1.477-.061 4.328-.061h.001zm0 1.892c-2.805 0-3.136.01-4.243.061-1.024.047-1.58.218-1.95.362-.49.19-.84.417-1.207.785a3.25 3.25 0 00-.785 1.207c-.145.37-.315.927-.362 1.95-.051 1.108-.062 1.44-.062 4.243 0 2.803.012 3.136.062 4.243.047 1.023.217 1.58.362 1.95.19.49.417.84.785 1.207a3.24 3.24 0 001.207.785c.37.144.926.315 1.949.362 1.108.05 1.44.06 4.244.06s3.135-.01 4.242-.06c1.024-.047 1.58-.218 1.95-.362.49-.19.84-.417 1.207-.785.368-.367.595-.717.786-1.207.144-.37.315-.927.362-1.95.05-1.108.06-1.44.06-4.243 0-2.803-.01-3.136-.061-4.243-.047-1.023-.217-1.58-.362-1.948a3.254 3.254 0 00-.785-1.21 3.254 3.254 0 00-1.207-.784c-.37-.144-.926-.315-1.949-.362-1.108-.05-1.44-.06-4.243-.06zm6.865 3.003a1.26 1.26 0 11-2.52 0 1.26 1.26 0 012.52 0zm-6.865.213a5.393 5.393 0 110 10.785 5.393 5.393 0 010-10.785zm0 8.892a3.5 3.5 0 100-7 3.5 3.5 0 000 7z","fill":"#ACACAC"}})])
          )
        }
      }
    